import { cn } from "@/modules/lib/utils"
import { BoxPlanningHeaderCenterView } from "@/modules/boxPlanning/components/boxPlanningHeader/boxPlanningHeaderCenterView"
import { Suspense } from "react"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { BoxProgramTemplateHeaderLeftView } from "@/modules/boxProgrammation/components/boxProgrammingHeader/boxProgramTemplateHeaderLeftView"
import { BoxTemplateHeaderRightView } from "@/modules/boxPlanning/components/boxTemplateHeader/boxTemplateHeaderRightView"

type BoxProgrammingHeaderProps = {
  className?: string
} & React.ComponentProps<"div">

export function BoxProgrammingHeader({ className, ...props }: BoxProgrammingHeaderProps) {
  return (
    <div className={cn("flex max-h-52 min-h-52 w-full justify-between gap-1 lg:gap-2 xl:gap-3", className)} {...props}>
      <div className="flex-1/4">
        <BoxProgramTemplateHeaderLeftView />
      </div>
      <div className="flex-2/4">
        <Suspense fallback={<LoadingSpinner />}>
          <BoxPlanningHeaderCenterView />
        </Suspense>
      </div>
      <div className="flex-1/4">
        <Suspense fallback={<LoadingSpinner />}>
          <BoxTemplateHeaderRightView />
        </Suspense>
      </div>
    </div>
  )
}
